// extracted by mini-css-extract-plugin
export default {"with-arrow-top":"with-arrow-top--eNlt9","withArrowTop":"with-arrow-top--eNlt9"};